<template>
  <v-container class="pa-0">
    <v-form ref="user-form" class="mb-2">
      <v-app-bar
        color="transparent"
        class="elevation-0 pa-0 page-header-toolbar"
      >
        <h2 class="my-2 text-uppercase font-weight-light">
          {{ $t("persons.overview") }}
        </h2>
      </v-app-bar>
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex :class="'pr-4 ' + (imageView ? 'xs12' : 'md2 sm4 xs5')">
                <v-img
                  :src="person.image_url ? person.image_url : no_image"
                  aspect-ratio="1"
                  @click="imageView = !imageView"
                ></v-img>
              </v-flex>
              <v-flex :class="imageView ? 'xs12' : 'md10 sm8 xs7'">
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <p
                      :class="
                        'font-weight-bold text-uppercase mb-1 ' +
                          (imageView ? 'text-center' : '')
                      "
                    >
                      {{ person.first_name }}
                    </p>
                    <p
                      :class="
                        'font-weight-bold text-uppercase mb-1 ' +
                          (imageView ? 'text-center' : '')
                      "
                    >
                      {{ person.last_name }}
                    </p>
                    <p :class="'mb-1 ' + (imageView ? 'text-center' : '')">
                      {{ $t("persons.dob") }}: {{ computedDateofBirth }}
                    </p>
                    <p :class="'mb-1 ' + (imageView ? 'text-center' : '')">
                      {{
                        $t("users.unique_id") +
                          ": " +
                          (person.unique_id ? person.unique_id : "")
                      }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="user.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{
              $t("certificates.expertise")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-text-field
              :label="$t('global.search')"
              v-model="ct_search_params.any"
              @keydown="checkKeyPressFilterExpertise"
              hide-details
              dark
              class="pa-0 ma-0 mt-2"
              autocomplete="off"
            ></v-text-field>
            <action-button
              type="new"
              :icon_only="true"
              @click="showForm(null, 'certificate')"
              v-if="$can('certificate-create')"
              small
            />
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="ct_headers"
                  :items="certificates"
                  :items-per-page="certificates.length"
                  :options.sync="ct_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this
                      .DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t(
                      'global.items_per_page_all_text',
                    ),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text'),
                  }"
                  :server-items-length="ct_total"
                  :loading="ct_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :disable-sort="true"
                  :class="'user-dt'"
                  mobile-breakpoint="0"
                  dense
                  :must-sort="true"
                >
                  <template v-slot:item="{ item, index }">
                    <tr
                      v-for="(row, idx) in item.row_titles"
                      :key="item.id + '-' + idx"
                      :class="
                        item.row_titles && item.row_titles.length > 1
                          ? 'grouped ' + (index % 2 == 1 ? 'odd' : 'even')
                          : ''
                      "
                    >
                      <td>
                        <router-link
                          :to="{
                            path:
                              BACKEND_URL +
                              '/qrcode/user/' +
                              id +
                              '/expertise/' +
                              item.id,
                            props: { hash: id, id: item.id },
                          }"
                        >
                          {{ item.row_titles[idx] }}
                        </router-link>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card :class="'mt-4'" v-if="user.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{
              $t("courses.title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              :label="$t('global.search')"
              v-model="c_search_params.any"
              @keydown="checkKeyPressFilterCourse"
              hide-details
              dark
              class="pa-0 ma-0"
              autocomplete="off"
            ></v-text-field>
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="c_headers"
                  :items="courses"
                  :items-per-page="courses.length"
                  :options.sync="c_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this
                      .DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t(
                      'global.items_per_page_all_text',
                    ),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text'),
                  }"
                  :server-items-length="c_total"
                  :loading="c_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :disable-sort="true"
                  dense
                  :must-sort="true"
                >
                  <template v-slot:item.theory_test="{ item }">
                    {{ $dd_attendees_theory_test(item.theory_test) }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_enrolment_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <p class="caption d-block font-weight-light text-center mt-5">
          {{ $t("persons.last_updated_sync") }}: {{ computedLastDateSynced }}
        </p>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

export default {
  components: { ActionButton },
  name: "QRCodeUserInfo",

  props: ["id"],

  data() {
    return {
      page_title: "",
      isAdmin: false,

      encodedId: "",
      user: {},
      person: {},

      dob_date_menu: false,
      dob_employeed_from: false,

      showUploadForm: false,
      person_image: null,

      showQRCodeScanner: false,

      courses: [],
      c_total: 0,
      c_show_loading: false,
      c_show_filter: false,
      c_refresh: false,
      c_pagination: {
        page: this.$getLocalStorage("__page_User_QrInfo_Course_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"],
      },
      c_search_params: {
        any: "",
      },

      certificates: [],
      ct_total: 0,
      ct_show_loading: false,
      ct_show_filter: false,
      ct_refresh: false,
      ct_pagination: {
        page: this.$getLocalStorage(
          "__page_User_QrInfo_Certificate_List",
          "page",
        ),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"],
      },
      ct_search_params: {
        any: "",
      },

      dictionary: {
        attributes: {
          "person.first_name": this.$t("persons.first_name"),
          //"person.middle_name": this.$t("persons.middle_name"),
          "person.last_name": this.$t("persons.last_name"),
          "person.email": this.$t("persons.email"),
          "person.date_of_birth": this.$t("persons.date_of_birth"),
          "person.employeed_from": this.$t("persons.employeed_from"),
          "person.company": this.$t("persons.company"),
          "person.mobile": this.$t("persons.mobile"),
          "person.comments": this.$t("persons.comments"),
          "person.street": this.$t("persons.street"),
          "person.city": this.$t("persons.city"),
          "person.state": this.$t("persons.state"),
          "person.zip": this.$t("persons.zip"),
          "person.country": this.$t("persons.country"),
        },
      },

      currentFormId: "",
      currentForm: "",
      showDialogForm: false,

      imageView: false,
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
    this.loadUser()
  },

  watch: {
    c_refresh: {
      handler() {
        if (this.c_refresh) {
          this.course_list()
        }
      },
    },
    c_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_User_QrInfo_Course_List", newVal.page)
          }

          this.c_refresh = true
        }
      },
    },
    ct_refresh: {
      handler() {
        if (this.ct_refresh) {
          this.certificate_list()
        }
      },
    },
    ct_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem(
              "__page_User_QrInfo_Certificate_List",
              newVal.page,
            )
          }

          this.ct_refresh = true
        }
      },
    },
    current: {
      handler() {
        if (_.has(this.current, "id")) {
          this.loadUser()
        }
      },
    },
  },

  computed: {
    c_headers: {
      get() {
        return [
          { text: this.$t("courses.name"), value: "name" },
          { text: this.$t("courses.start"), value: "start_date" },
          { text: this.$t("courses.end"), value: "end_date" },
          { text: this.$t("courses.status"), value: "status" },
        ]
      },
    },
    ct_headers: {
      get() {
        return [
          { text: this.$t("certificates.title"), value: "title" },
          //{ text: this.$t("certificates.issued_date"), value: "issued_date" },
          //{ text: this.$t("certificates.issued_by"), value: "issued_by" },
          //{ text: this.$t("certificates.company"), value: "company_name" },
        ]
      },
    },
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.person.date_of_birth)
      },
      set(val) {
        this.$set(this.person, "date_of_birth", this.$dateFormatSetter(val))
      },
    },
    computedLastDateSynced: {
      get() {
        return (
          this.$dateFormatGetter(
            this.person.last_sync_date,
            this.MYSQL_DATETIME_FORMAT,
          ) +
          " " +
          this.$timeFormatGetter(
            this.person.last_sync_date,
            this.MYSQL_DATETIME_FORMAT,
          )
        )
      },
      set(val) {
        this.$set(this.person, "last_sync_date", this.$dateFormatSetter(val))
      },
    },
    computedEmployeedFrom: {
      get() {
        return this.$dateFormatGetter(this.person.employeed_from)
      },
      set(val) {
        this.$set(this.person, "employeed_from", this.$dateFormatSetter(val))
      },
    },
  },

  methods: {
    loadUser() {
      let encoded = this.id

      if (encoded) {
        let decoded = this.$decryptString(this.id)
        decoded = decoded.split("^|^")

        if (decoded.length == 2) {
          this.encodedId = decoded[0]

          axios
            .get(this.API_URL + "user/" + this.encodedId)
            .then(res => {
              this.user = res.data.data
              this.person = res.data.data.person

              // Add session checker
              this.$cookieChecker(
                `${this.COOKIE_PREFIX}qr_token_` + this.user.id,
                () => {
                  this.$awn.alert(this.$t("users.qr_use_access_expired"))
                  this.$router.push(this.BACKEND_URL + "/my")
                },
              )

              this.setPageTitle()
              this.course_list()
              this.certificate_list()

              this.isAdmin =
                this.$hasRole("system-developer") || this.$hasRole("superuser")
            })
            .catch(err => console.log(err))
        }
      }
    },

    setPageTitle() {
      this.page_title = this.page_title = this.$t("users.edit_user", {
        name: this.person.first_name + " " + this.person.last_name,
      })
    },

    course_list() {
      if (this.user.id) {
        this.c_show_loading = true

        let query = this.$queryString(this.c_pagination, {
          ...this.c_search_params,
          user_id: this.user.id,
        })

        axios.get(this.API_URL + "courses?" + query).then(res => {
          this.courses = res.data.data
          this.c_total = res.data.meta.total
          this.c_refresh = false
          this.c_show_loading = false

          this.c_pagination.page = res.data.meta.current_page
          this.c_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },

    certificate_list() {
      if (this.user.id) {
        this.ct_show_loading = true

        let query = this.$queryString(this.ct_pagination, {
          ...this.ct_search_params,
          user_id: this.user.id,
        })

        axios.get(this.API_URL + "certificates?" + query).then(res => {
          this.certificates = res.data.data
          this.ct_total = res.data.meta.total
          this.ct_refresh = false
          this.ct_show_loading = false

          this.ct_pagination.page = res.data.meta.current_page
          this.ct_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },

    filterExpertise() {
      this.ct_pagination.page = 1
      this.ct_refresh = true
    },

    filterCourse() {
      this.c_pagination.page = 1
      this.c_refresh = true
    },

    checkKeyPressFilterExpertise(e) {
      if (e.key == "Enter") {
        this.filterExpertise()
      }
    },

    checkKeyPressFilterCourse(e) {
      if (e.key == "Enter") {
        this.filterCourse()
      }
    },
  },
}
</script>

<style>
.fab-update-image {
  bottom: 5px !important;
  right: 0px !important;
}
.user-dt .v-data-table-header {
  display: none !important;
}
</style>
